import { render, staticRenderFns } from "./permissionLocation.template.vue?vue&type=template&id=795125c2&scoped=true&"
var script = {}
import style0 from "./permissionLocation.template.vue?vue&type=style&index=0&id=795125c2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795125c2",
  null
  
)

export default component.exports